<p-fileUpload [auto]="true" #fileUpload name="file[]" [url]="fileUploadUrl" (onUpload)="onUpload($event)"
  (onBeforeUpload)="onBeforeUpload($event)" (onError)="onUploadError($event)" [accept]="accept" [headers]="appheaders"
  [chooseLabel]="uploadButtonLabel" [maxFileSize]="maxSize" [invalidFileSizeMessageSummary]="maxSizeMessage"
  (onSelect)="onFileSelect($event)">
</p-fileUpload>